import * as _ from 'underscore'

import { Enums } from "../models/common"
import { ColumnInfo } from "../models/custom"
import { OpTariff } from "../models/core/op-tariff"

import { DataProvider } from "../helpers/data-provider"
import { ConvertHelper } from "../helpers/convert-helper"

export class DataProviderTariff {

    // #region Ctor

    constructor(private dataProvider: DataProvider) { }

    // #endregion


    //#region Get
    
    public getTariff = (id: number): JQueryPromise<OpTariff> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetTariff', { IdTariff: id }, 'OpxGetTariffResult')
            .then((result: any) => {
                if (result != null) {
                    const tariff: OpTariff = new OpTariff(result)

                    return OpTariff
                        .loadNavigationProperties(this.dataProvider, [tariff])
                        .then((tariffs: OpTariff[]) => {
                            return _.first(tariffs)
                        })
                    }

                return null
            })
        }

    public getTariffFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpTariff>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdTariff, 'OpxTariffFilter', 'OpxTariffFilterResult')
    }

    //#endregion


    //#region Delete

    public deleteTariff = (opObj: OpTariff): JQueryPromise<void> => {
        return this.dataProvider.sendRequestWithSession('OpxDeleteTariff', { ToBeDeleted: opObj.toJSON() }, null)
    }

    //#endregion


    // #region Save

    public saveTariff = (opObj: OpTariff): JQueryPromise<OpTariff> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveTariff', { ToBeSaved: opObj.toJSON() }, 'OpxSaveTariffResult')
            .then((result: any) => {
                if (result != null) {
                    const tariff: OpTariff = new OpTariff(result)

                    return OpTariff
                        .loadNavigationProperties(this.dataProvider, [tariff])
                        .then((tariffs: OpTariff[]) => {
                            return _.first(tariffs)
                        })
                }

                return null
            })
    }

    public copyTariff = (opObj: OpTariff): JQueryPromise<OpTariff> => {
        return this.dataProvider
            .sendRequestWithSession('OpxCopyTariff', { ToBeSaved: opObj.toJSON() }, 'OpxCopyTariffResult')
            .then((result: any) => {
                if (result != null) {
                    const tariff: OpTariff = new OpTariff(result)

                    return OpTariff
                        .loadNavigationProperties(this.dataProvider, [tariff])
                        .then((tariffs: OpTariff[]) => {
                            return _.first(tariffs)
                        })
                }

                return null
            })
    }

    // #endregion
}
